module.exports = __webpack_public_path__ + "static/media/bike.f1bc5c25.svg";